import React, { useState, useEffect } from 'react';
import { Card, Col, Container, Nav, Navbar, Row, Modal } from 'react-bootstrap';
import c1 from '../Images/c1.jpg';
import c2 from '../Images/c2.jpg';
import c3 from '../Images/c3.jpeg';
import c4 from '../Images/c4.jpeg';
import c5 from '../Images/c5.jpg';
import c6 from '../Images/c6.jpeg';
import c7 from '../Images/c7.jpg';
import c8 from '../Images/c8.jpg';
import c9 from '../Images/c9.jpg';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

export default function Collection() {

    // ⭐ Internal CSS for Scroll Animations
    const animationCSS = `
        .fade-up {
            opacity: 0;
            transform: translateY(40px);
            transition: all 0.8s ease-out;
        }
        .fade-up.animate {
            opacity: 1;
            transform: translateY(0);
        }
        .zoom-in {
            transform: scale(0.85);
            opacity: 0;
            transition: all 0.8s ease-out;
        }
        .zoom-in.animate {
            transform: scale(1);
            opacity: 1;
        }
    `;

    // ⭐ Scroll Animation Logic
    useEffect(() => {
        const elements = document.querySelectorAll(".fade-up, .zoom-in");

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("animate");
                    }
                });
            },
            { threshold: 0.2 }
        );

        elements.forEach((el) => observer.observe(el));

        return () => observer.disconnect();
    }, []);

    // ⭐ Collections Data
    const collections = [
        { img: c1, title: 'Evening Gown', text: 'Elegant handcrafted gown for special occasions.' },
        { img: c2, title: 'Graceful Saree Collection', text: 'Traditional yet trendy sarees that define elegance.' },
        { img: c3, title: 'Designer Jacket Saree', text: 'Fusion of modern jacket style with a classic saree look.' },
        { img: c4, title: 'Elegant Pink Saree', text: 'Soft and stylish, perfect for festive and formal wear.' },
        { img: c5, title: 'Bridal Collection', text: 'Finely tailored bridal wear for your special day.' },
        { img: c6, title: 'Traditional Saree Look', text: 'Classic South Indian style with intricate gold detailing.' },
        { img: c7, title: 'Elegant Traditional Kerala Look', text: 'Classic Kerala saree look with natural charm.' },
        { img: c8, title: 'Graceful Traditional Dance Attire', text: 'Rich red outfit with intricate traditional design.' },
        { img: c9, title: 'Regal Ivory Dance Ensemble', text: 'Elegant ivory outfit with golden embroidery and jewelry.' },
    ];

    // ⭐ Modal States
    const [show, setShow] = useState(false);
    const [selectedImg, setSelectedImg] = useState(null);

    const handleShow = (img) => {
        setSelectedImg(img);
        setShow(true);
    };

    const handleClose = () => setShow(false);

    return (
        <div>

            {/* ⭐ Inject CSS inside component */}
            <style>{animationCSS}</style>

            {/* 🔝 Navbar */}
            <Header />

            {/* 🖼️ Collections Section */}
            <div className="py-5 bg-light">
                <Container>
                    <h2 className="text-center mb-3 fw-bold text-dark fade-up">Our Collections</h2>
                    <div className="underline mx-auto mb-5 fade-up"></div>

                    <Row className="g-4 justify-content-center">
                        {collections.map((item, index) => (
                            <Col key={index} md={4} sm={6} xs={10} className="fade-up">
                                <Card className="collection-card shadow-sm border-0 bg-white zoom-in">
                                    <Card.Img
                                        variant="top"
                                        src={item.img}
                                        onClick={() => handleShow(item.img)}
                                        className="rounded-top"
                                        style={{
                                            cursor: "pointer",
                                            transition: "transform 0.3s"
                                        }}
                                        onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                                        onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
                                    />
                                    <Card.Body className="text-center">
                                        <Card.Title className="fw-semibold">{item.title}</Card.Title>
                                        <Card.Text className="text-muted">{item.text}</Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>

            {/* 🪟 Modal */}
            <Modal show={show} onHide={handleClose} centered size="md">
                <Modal.Body className="text-center bg-dark">
                    <img
                        src={selectedImg}
                        alt="preview"
                        className="img-fluid rounded"
                        style={{ maxHeight: "400px" }}
                    />
                </Modal.Body>
            </Modal>

            
            <Footer />

        </div>
    );
}
